export enum ActionMode {
    Edit = 'edit',
    Delete = 'DELETE_ITEM'
}
